import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer.js'
import Slider from "react-slick"
import ProductTabs from '../../components/ProductTabs'
import SEO from '../../components/SEO/SEO';
import { seoData } from '../../utils/seoData';

const DolomitePage = () => {

    const productData = {
        description: [
            "Dolomite is a naturally occurring calcium magnesium carbonate mineral [CaMg(CO₃)₂] widely used in construction, agriculture, steel manufacturing, and chemical industries. It is valued for its dual calcium and magnesium content, making it versatile for various industrial applications.",
            "Available in crushed, ground, and calcined forms with different particle sizes to meet specific application requirements.",
            "• Bags: typically 25 kg or 50 kg polypropylene or paper bags — ideal for agricultural and construction applications.",
            "• Jumbo bags (FIBC): 500 kg to 1000 kg bulk bags for efficient handling and storage in industrial operations.",
            "• Bulk delivery: available in tipper trucks, rail cars, or bulk carriers for large-scale mining, steel, and construction projects.",
            "• Loose bulk: for direct loading into silos, hoppers, or processing equipment at customer facilities.",
            "• Packing & labeling: all packages supplied with product specifications, particle size distribution, and chemical analysis. Packaging ensures product integrity during transport and storage."
        ],
        applications: [
            {
                id: 1,
                title: "Paints and Coatings",
                description: "Dolomite powder acts as a cost-effective filler and extender in the paints and coatings industry. Its high whiteness and excellent dispersion properties enhance the finish and durability of paints. As a top dolomite powder manufacturer in Rajasthan, India, we supply products tailored to industry-specific requirements.",
                image: "/images/products/dolomite/paints.jpg"
            },
            {
                id: 2,
                title: "Glass Manufacturing",
                description: "Dolomite powder is an essential ingredient in glass manufacturing, where it improves strength and thermal resistance. Our premium dolomite powder in India is a preferred choice for glassmakers looking for high-quality materials.",
                image: "/images/products/dolomite/glass.jpg"
            },
            {
                id: 3,
                title: "Agriculture",
                description: "Used as a soil conditioner, dolomite powder helps neutralize acidity and enrich soil with essential nutrients like calcium and magnesium. Speciality Geochem’s products are trusted by farmers and agricultural industries across India.",
                image: "/images/products/dolomite/agri.jpg"
            },
            {
                id: 4,
                title: "Ceramics and Tiles",
                description: "In ceramics and tile manufacturing, dolomite powder enhances strength and provides a smooth finish. We are proud to be a leading dolomite manufacturer in India, offering products that improve the quality of ceramic goods.",
                image: "/images/products/dolomite/titles.jpg"
            }
        ]
    };

    return (
        <Fragment>
            <SEO title={seoData.dolomite.title} description={seoData.dolomite.description} keywords={seoData.dolomite.keywords} />
            <Navbar/>
            <PageTitle pageTitle="Dolomite" pagesub="Dolomite" parentPage="Products" parentLink="#" />
            <div className="team-pg-area product-page-section">
                <div className="container">
                    <div className="team-info-wrap">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="team-info-img">
                                    <Slider dots={true} arrows={true} infinite={true} speed={500} slidesToShow={1} slidesToScroll={1} autoplay={true} autoplaySpeed={3000}>
                                        <div className="image-box">
                                            <img src='/images/products/dolomite/d1.jpg' alt="Dolomite" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/dolomite/d2.jpg' alt="Dolomite Crushed" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/dolomite/d3.jpg' alt="Dolomite Powder" />
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="team-info-text">
                                    <h2>Dolomite [CaMg(CO₃)₂]</h2>
                                    <ul>
                                        <li>Chemical Formula: <span>CaMg(CO₃)₂</span></li>
                                        <li>CaO Content: <span>30-32%</span></li>
                                        <li>MgO Content: <span>18-21%</span></li>
                                        <li>Packaging: <span>25kg, 50kg Bags, Bulk</span></li>
                                        <li>Form: <span>Crushed, Ground, Calcined</span></li>
                                        <li>Particle Size: <span>Customizable</span></li>
                                        <li>Color: <span>White to Grey</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ProductTabs product={productData} />
                </div>
            </div>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};

export default DolomitePage;
